import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/AllysonHurley_Pet/video.jpg';
import subs from '@/static/assets/reviews/AllysonHurley_Pet/subs.vtt';

export const AllysonHurley: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Allyson',
  videoUrl: `${ASSETS_URL}/pet/AllysonHurley_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
